import { useAxiosPrivate } from 'shared/hooks'
import { useQuery } from 'libs/query'
import { CurrenciecRes } from 'shared/types/general.types'
import { apiRoutes } from 'config/apiRoutes'
import { useContext } from 'react'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'

export const useFetchCurrencies = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const fetchCurrencies = () =>
		axiosPrivate
			.options(apiRoutes.settings)
			.then((res) => res?.data?.actions?.PUT?.currency?.choices)

	const { data: currencies, isLoading: currenciesIsLoading } = useQuery<CurrenciecRes>({
		queryKey: queryKeys.currencies.all,
		queryFn: fetchCurrencies,
		enabled: !!auth.accessToken
	})

	return {
		currencies,
		currenciesIsLoading
	}
}
